import { each, $ } from '../util'

/**
 * @module UniversitySelector
 */
const UniversitySelector = (() => {

  const selectorsValues = {}

  const manageButtons = () => {
    const buttons = document.querySelectorAll('.js-uiniversity-button')
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const year = button.getAttribute('data-year')
        const typology = button.getAttribute('data-typology')
        const selector = document.querySelector(`.js-uni-selector[data-selector="${year}"]`)
        selector.querySelector('.js-uiniversity-selector-typology').value = typology
      })
    })
  }

  const manageSelector = (selector) => {
    const selectorType = selector.getAttribute('data-selector')
    selectorsValues[selectorType] = {}

    const courseSelectorsRequired = selector.querySelectorAll('.js-uni-selector-course-selector-required')
    each(courseSelectorsRequired, (_i, courseSelectorRequired) => {
      const group = courseSelectorRequired.getAttribute('data-group')
      const value = courseSelectorRequired.getAttribute('data-value')

      selectorsValues[selectorType][group] = value
    })

    const courseSelectors = selector.querySelectorAll('.js-uni-selector-course-selector')
    each(courseSelectors, (_i, courseSelector) => {
      courseSelector.addEventListener('click', (e) => {
        e.preventDefault()

        const group = courseSelector.getAttribute('data-group')
        const value = courseSelector.getAttribute('data-value')
        selectorsValues[selectorType][group] = value
        
        each(courseSelectors, (_i, c) => {
          if (c.getAttribute('data-group') !== group) return

          if (c == courseSelector) {
            c.classList.remove('c-button--main')
            c.classList.add('c-button--success')
            c.innerText = c.getAttribute('data-selected')
          } else {
            c.classList.add('c-button--main')
            c.classList.remove('c-button--success')
            c.innerText = c.getAttribute('data-select')
          }
        })
      })
    })

    const submit = selector.querySelector('.js-uni-selector-submit')
    submit.addEventListener('click', (e) => {
      const groupNodes = selector.querySelectorAll('[data-group]')
      const groups = []
      
      groupNodes.forEach((g) => {
        const value = g.getAttribute('data-group')
        if (!(groups.indexOf(value) > -1))
          groups.push(value)
      })

      const requested = groups
      const compiled = Object.keys(selectorsValues[selectorType])

      if (requested.length != compiled.length) {
        e.preventDefault()
        alert(selector.getAttribute('data-alert'))
        return
      }

      const year = selector.querySelector('.js-uiniversity-selector-year')
      const courses = selector.querySelector('.js-uiniversity-selector-courses')

      year.value = selectorType
      courses.value = Object.values(selectorsValues[selectorType]).join(',')
    })
  }

  const init = () => {
    const selectors = $('.js-uni-selector')
    if (!selectors || selectors.length < 1) return

    each(selectors, (_i, selector) => {
      manageSelector(selector)
    })

    manageButtons()
  }

  return {
    init
  }
})()

export default UniversitySelector



// WEBPACK FOOTER //
// app/javascript/scripts/components/UniversitySelector.js